<div class="header" *ngIf="hideHeader">
  <div class="left-logodiv">
    <div class="logo" (click)="menuHandler()">
      <img src="../../../assets/images/hamburger-icon.svg" alt="Menu" />
    </div>
    <div class="logo-title">
      <img src="../../../assets/images/header-left-logo.svg" alt="Logo" class="J&J MedTech" />
    </div>
  </div>
  <div class="login-userinfo">
    <div class="role-switch-div">
      <h1 class="product_label" [style.fontSize.px]="getFontSize(productLabel)">{{ capitalizeFirstLetter(productLabel)
        }}</h1>
    </div>
    <div class="category-wrapper" *ngIf="showDropdown && !hideProfile && showRole">
      <span class="category-txt">Role</span>
      <mat-form-field class="mb-cat cust-select" [formGroup]="menuForm">
        <mat-select class="header-cat-select" formControlName="roleName" (selectionChange)="changeRole($event)">
          <mat-option *ngFor="let role of dropdownOptions" [value]="role.value">{{ role.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="lui">
      <div class="dropdown">
        <img class="user-img-lu" [src]="profileImageUrl" alt="Profile" *ngIf="!hideProfile && isExistProfileImage"
          (click)="toggleDropdown($event)" />
        <img class="user-img-lu" src="../../../assets/images/JJMT_Icon_Web_Profile.svg" alt="Profile"
          *ngIf="!hideProfile && !isExistProfileImage" (click)="toggleDropdown($event)">
        <img class="user-img-lu without-dropdown" [src]="profileImageUrl" alt="Profile"
          *ngIf="hideProfile && isExistProfileImage">
        <img class="user-img-lu without-dropdown" src="../../../assets/images/JJMT_Icon_Web_Profile.svg" alt="Profile"
          *ngIf="hideProfile && !isExistProfileImage">
        <div class="dropdown-content">
          <span (click)="profileInfo()">{{givenName}} - {{displayRole}}</span>
          <div class="select-role">
            <span *ngIf="showDropdown && !hideProfile && !showRole">
              <mat-form-field class="mb-cat cust-select" [formGroup]="menuForm">
                <mat-select class="header-cat-select" formControlName="roleName" (selectionChange)="changeRole($event)">
                  <mat-option *ngFor="let role of dropdownOptions" [value]="role.value">{{ role.label }}</mat-option>
                </mat-select>
              </mat-form-field></span>
          </div>
          <span (click)="help($event)">Help</span>
          <span (click)="userGuide($event)">User Guide</span>
          <span (click)="releaseNotes()">Release Notes</span>
          <span (click)="logout()">Logout</span>
        </div>
      </div>
    </div>
  </div>
</div>